/* Component to display an error Message box */
import { tokens, Text } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

import { SlideInLeft } from '@hotjar/webapp/utils/animations';
import { ErrorMessage as ErrorMessageBox } from '@hotjar/webapp/components/Message';
import { useTranslation } from 'react-i18next';

interface SsoErrorMessageProps {
  errorCode: string | null;
}

const StyledErrorMessage = styled(ErrorMessageBox)`
  margin-top: ${tokens.spacer.x4};
  animation: ${SlideInLeft} 0.3s forwards;
`;

export const SsoErrorMessage = ({ errorCode }: SsoErrorMessageProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (!errorCode) {
    return null;
  }

  return (
    <StyledErrorMessage>
      <Text as="p" textColor="inherited" textType="subtitle1">
        {t(`activation:saml-sso.errors.error-code-${errorCode}.title`)}
      </Text>
      <Text as="p" textColor="inherited" textType="body2">
        {t(`activation:saml-sso.errors.error-code-${errorCode}.description`)}
      </Text>
    </StyledErrorMessage>
  );
};
